<template>
  <div id="voting_mc" class="px-3 px-sm-0">
    <div v-if="solutions" class="espMcCheck" >
        <v-checkbox  v-for="(element,index) in solutions" :key="index"
        v-model="selected"
        :value="element"
        hide-details
        :disabled="disableInteraction ? true : false"
        :class="{'espMcCheckBlack':isChecked(element)}"        
        >
            <template #prepend>
            <span class="espMcLabel pa-2 px-4 text-sm-h6" :class="(isChecked(element)?'black--text espMcCheckBlack':'grey--text')">{{showLetter(index+1)}}</span>
            </template>
            <template #label>
                <span class="pa-4" :class="(isChecked(element)?'black--text':'grey--text')">{{element}}</span></template>
            <template #append>
                <v-icon class="pa-4" v-if="isChecked(element)" dense color="black">mdi-check-circle</v-icon>
            </template>
        </v-checkbox>
    </div>
    <info-message
      v-if="isMaxOptionsAllowed()"
      icon="mdi-alert-circle"
      :message="isMaxOptionsAllowedAlertMessage"
      isSticky
      backgroundColor="#FFFFFF"
    ></info-message>

    <info-message
      v-if="isMaxOptionsExactAllowed()"
      icon="mdi-alert-circle"
      :message="isMaxOptionsAllowedExactAlertMessage"
      isSticky
      backgroundColor="#FFFFFF"
    ></info-message>
  </div>
  
</template>

<script>
import {layoutMixin} from '@/utils/layout-mixin'
import {solutionMixin} from '@/utils/solution-mixin'
import InfoMessage from '@/components/spots/InfoMessage.vue';

export default {
   components: { InfoMessage },
  mixins:[layoutMixin,solutionMixin],
  props: {
    spot: {},
    color: {},
    selectedColor: {}
  },
  data() {
    return {
        selected:[],
        valid:null,
        colorValue: this.color,
        selectedColorValue: this.selectedColor,
        disableInteraction:false
    };
  },
  mounted() {
      this.setResponses();
      this.assignPseudoElementStyle();
   },
    watch:{
      selected(){          
          if (this.disableInteraction) return;
          this.isMaxOptionsAllowed();
          this.isMaxOptionsExactAllowed();
          let validInput=this.isValid();
          let serverInput=validInput?this.getServerData(this.selected):null;
          let input=validInput?this.selected:[];
          this.$emit('input',input,serverInput);
      }
},
methods:{
    setResponses(){        
        if ( this.spot.tstatus == 3 || this.spot.tstatus == 4 ){
            this.disableInteraction = true;   
            let inputJson = this.spot.raetsel.user_input_json;
            if(typeof this.spot.raetsel.user_input_json !== 'object'){
                inputJson = JSON.parse(this.spot.raetsel.user_input_json)
            }   
            this.spot.raetsel.lsg.forEach((element)=>{
                if (inputJson[element]){
                    this.selected.push(element);
                }
            })        
        }
    },
    isValid(){
        if(this.spot && this.spot.raetsel && this.selected){
            if(this.spot.raetsel.max_votes <= 0 && !this.spot.raetsel.max_votes_exact){
                return true;
            }
            if(this.spot.raetsel.max_votes_exact && this.selected.length==this.spot.raetsel.max_votes){
                return true
            }
            if(!this.spot.raetsel.max_votes_exact && this.spot.raetsel.max_votes > 0 && this.selected.length<=this.spot.raetsel.max_votes){
               return true;
            }
        }
        return false;
    },
    isChecked(sol){
        return this._.includes(this.selected,sol);
    },
    showLetter(number){
        let alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZ"
        let result = ""
        if(this._.isNumber(number)){
            let charIndex = number % alphabet.length
            let quotient = number/alphabet.length
            if(charIndex-1 == -1){
                charIndex = alphabet.length
                quotient--;
            }
            result =  alphabet.charAt(charIndex-1) + result;
            if(quotient>=1){
                result=this.showLetter(parseInt(quotient))+result;
            }
        }
        return result;
    },
    isMaxOptionsAllowed() {
        if(!this.disableInteraction  && this.spot.raetsel.max_votes <this.selected.length ){
            return true;
        }else{
            return false;
        }
    },
    isMaxOptionsExactAllowed() {
        if(!this.disableInteraction && this.spot.raetsel.max_votes_exact &&  this.spot.raetsel.max_votes > this.selected.length){
            return true;
        }else{
            return false;
        }
    },
    assignPseudoElementStyle() {
        this.colorValue = this.theme.textColor;
        this.selectedColorValue = this.theme.btnColorPrimary;
        document.documentElement.style.setProperty('--color', this.colorValue);
        document.documentElement.style.setProperty('--selected-color', this.selectedColorValue);
    }
 },
computed: {
    isMaxOptionsAllowedAlertMessage(){
        return this.$tc('solveVotingVotesFull', this.spot.raetsel.max_votes, {
            votes: this.spot.raetsel.max_votes
        });
    },
    isMaxOptionsAllowedExactAlertMessage(){
        let count = this.spot.raetsel.max_votes - this.selected.length;
      return this.$tc("solveVotingMissingVotes", count, {votes: count});
    }
  },
};
</script>

<style lang="scss">
#voting_mc {
    .espMcCheck div.v-input--selection-controls__input{
        display:none!important;
    }
    .espMcCheck .v-input--checkbox{
        border:solid 2px var(--color) ;
        border-radius: 10px;
        -moz-border-radius:10px;
        -webkit-border-radius:10px;
    }
    .espMcCheck .espMcCheckBlack.v-input--checkbox{
        border-color: var(--selected-color);
    }
    .espMcLabel{
        border-right:2px solid var(--color);
    }
    .espMcLabel.espMcCheckBlack{
        border-color:var(--selected-color);
    }
    .espMcCheck .espMcCheckBlack .v-input__append-outer > .v-icon{
        color: var(--selected-color)!important; /* doesnt work because it is isabled*/
    }
    .espMcCheck {
        .correctAnswer {
            &.v-input--checkbox {
                border-color: #8CE9BD;
            }
        }
        .wrongAnswer {
            &.v-input--checkbox {
                border-color: #D6787D;
            }
        }
        .espMcCheckBlack {
            .v-icon {
                &.correctAnswerIcon {
                  color: #00EF7A!important;
                }
                &.wrongAnswerIcon {
                  color: #FB4143!important;
                }
            }
               &.correctAnswerIcon {
                  border-color: #00EF7A!important;
                }
                &.wrongAnswerIcon {
                  border-color: #FB4143!important;
                }
        }
        .espMcLabel  {
             &.correctAnswerIcon {
                  border-color: #00EF7A;
            }
        }
    }
    .grey--text {
       color: var(--color) !important;
    }
    .black--text {
         color: var(--selected-color) !important;
    }
}
</style>
